import styled from 'styled-components';
import { Body6, Body4 } from './../../app/common/typography';

export const ContentArea = styled.div`
  margin: 100px ${({ theme }) => theme.spacing.md};
  margin-bottom: 98px;
`;

export const DateAndBackContianer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: ${({ theme }) => theme.spacing.sm};
`;

export const DateInfoContent = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.xs};
`;

export const ActionPlanSeriesBack = styled(Body6)`
  text-decoration: underline;
`;

export const BorderBox = styled.div`
  border: 0.5px solid ${({ theme }) => theme.colors.platinum};
  border-radius: ${({ theme }) => theme.radius.s};
`;

export const OwnerTable = styled.table``;

export const AssessmentTypeTable = styled.table`
  border-bottom: 0.5px solid ${({ theme }) => theme.colors.platinum};
  margin: ${({ theme }) => theme.spacing.none};
  margin-bottom: ${({ theme }) => theme.spacing.l};
`;

export const TextPill = styled.span<{ color: string }>`
  height: 25px;
  border-radius: ${({ theme }) => theme.radius.s};
  text-align: center;
  display: block;
  background-color: ${({ color, theme }) => color || theme.colors.white};
`;

export const TextCompleted = styled.span`
  height: 25px;
  border-radius: ${({ theme }) => theme.radius.s};
  text-align: center;
  display: block;
  background-color: #219917;
`;

export const TextRejected = styled.span`
  height: 25px;
  border-radius: ${({ theme }) => theme.radius.s};
  text-align: center;
  display: block;
  background-color: #cc3044;
`;

export const TextApproval = styled.span`
  height: 25px;
  border-radius: ${({ theme }) => theme.radius.s};
  text-align: center;
  display: block;
  background-color: #f2cb15;
`;

export const CardParentContainer = styled.div`
  background: ${({ theme }) => theme.colors.white};
  box-shadow:
    0px 0.3px 0.9px rgba(0, 0, 0, 0.1),
    0px 1.6px 3.6px rgba(0, 0, 0, 0.13);
  border-radius: 6px;
  padding: ${({ theme }) => theme.spacing.sm};
  margin-bottom: ${({ theme }) => theme.spacing.m};
`;

export const CardParentContent = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const CardInfo = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.md};
  margin-bottom: ${({ theme }) => theme.spacing.sm};
`;

export const TitleMessage = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.xs};
`;

export const TitleInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.xs};
`;

export const AddAttachmentsText = styled(Body6)`
  text-decoration-line: underline;
  color: ${({ theme }) => theme.colors.dimGray};
`;

export const LoaderText = styled(Body6)`
  color: ${({ theme }) => theme.colors.battleShipGray};
  text-align: center;
  width: 100%;
`;

export const ImgListContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${({ theme }) => theme.spacing.sm};
`;

export const Table = styled.table`
  border-bottom: ${({ theme }) => theme.colors.platinum};
  margin: ${({ theme }) => theme.spacing.none};
  margin-bottom: ${({ theme }) => theme.spacing.m};
  border-bottom: 0.5px solid ${({ theme }) => theme.colors.platinum};
`;

export const StandardTable = styled.table`
  background: ${({ theme }) => theme.colors.seasalt};
  border-radius: ${({ theme }) => theme.radius.m};
`;

export const NotesContainer = styled.div`
  white-space: pre-wrap;
  border: 1px solid ${({ theme }) => theme.colors.platinum};
  padding: ${({ theme }) => theme.spacing.s};
  border-radius: ${({ theme }) => theme.radius.xs};
  background: #f7f8f8;
`;

export const NotesTitle = styled.div`
  display: flex;
  justify-content: space-between;
  border-bottom: 0.5px solid ${({ theme }) => theme.colors.platinum};
  padding-bottom: ${({ theme }) => theme.spacing.sm};
`;

export const RelatedComment = styled(Body4)`
  padding-top: 10px;
  color: ${({ theme }) => theme.colors.eerieBlack};
`;

export const ButtonContainer = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.sm};
`;

export const MessageDescriptionContainer = styled.div<{ error?: boolean }>`
  padding: ${({ theme }) => theme.spacing.sm};
  border: ${({ error }) => (error ? `1px solid red` : `none`)};
  border-radius: ${({ theme }) => theme.radius.s};
  min-height: ${({ theme }) => theme.spacing.xl};
  white-space: pre-wrap;
  word-wrap: break-word;
  background-color: ${({ theme }) => theme.colors.seasalt};
  color: ${({ theme }) => theme.colors.eerieBlack};
  cursor: not-allowed;
`;
